import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@els/els-react--modal';
import StructureToBase64 from './StructureToBase64';
import SwitcherTo3D from './SwitcherTo3D';
import ViewIn3D from './ViewIn3D';

import './StructureDialog.scss';

export default function StructureDialog(props) {
  const { show3dButton, structure, projectName, selfClose, structureName } = props;
  const [editorView, setEditorView] = useState(false);

  const headerId = 'structure-dialog-title';

  return (
    <Modal id="structure-dialog" className="structure-dialog" onClose={selfClose} label="Structure Image">
      <div className="structure-dialog--header">
        <h3 id={headerId} className="structure-dialog--header-title">
          Structure
        </h3>
      </div>
      <div className="structure-dialog--subheader">
        {show3dButton && <SwitcherTo3D editorView={editorView} setEditorView={setEditorView} />}
      </div>
      <div className="structure-dialog--content-wrapper">
        {editorView ? (
          <ViewIn3D structure={structure} />
        ) : (
          <StructureToBase64 structure={structure} structureName={projectName || structureName} />
        )}
      </div>
    </Modal>
  );
}

StructureDialog.propTypes = {
  structure: PropTypes.string.isRequired,
  show3dButton: PropTypes.bool,
  projectName: PropTypes.string,
  selfClose: PropTypes.func,
  structureName: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      name: PropTypes.string,
      isLinearFormula: PropTypes.bool,
    }),
  ]),
};
